<template>
  <collapsible-section
    class="collapse-item"
    :id="`objectModelRelationshipsCollapse-${objectModel.client_id}-${level}-${dropdownControlId}`"
    control-name="objectModelRelationshipsCollapse"
    :is-open="startOpened || isOpen(handler.hasObjectModelRelationshipMatch(lowerQ, objectModel))"
  >
    <template #section-header>
      <row>
        <prefix>
          <icon glyph="relationships" />
        </prefix>
        <column> About Record </column>
      </row>
    </template>
    <template #section-contents>
      <field-item
        v-for="prop in handler.objectModelMetadataSection(lowerQ, objectModel)"
        :key="prop.clientIdOrId"
        :disabled="handler.isDisabled(prop, computedChildTreeContext)"
        @click="select(handler.metaDataSelect(prop, objectModel, completePathFor(prop)))">
        <row>
          <column>
            {{ prop.name }}
          </column>
        </row>
      </field-item>
    </template>
  </collapsible-section>
</template>

<script lang="ts">
import Vue from "vue";
import handlerComponentsMixin from "~/components/dynamicFieldsTrees/mixins/handlerComponentsMixin";
import CollapsibleSection from "./common/collapsible-section.vue";
import ObjectModel from "~/models/objectModel";
import { ReferencePathNode } from "~/models/referencePaths/referencePathNode";
import handlerTreeContextMixin from "~/components/dynamicFieldsTrees/mixins/handlerTreeContextMixin";
import DynamicElementMixin from "./common/dynamic-element-mixin.vue";
import DynamicFieldsHandler from "~/models/dynamicFields/handlers/dynamicFieldsHandler";
import ObjectModelAccountRelationData from "~/components/dynamicFieldsTrees/handlerComponents/object-model-account-relation-data.vue";
import { IDynamicTreeContext } from "~/interfaces/dynamicFieldsInterfaces";
import ObjectModelPropertyDefinition from "~/models/objectModelProperties/objectModelPropertyDefinition";
import FieldItem from './common/field-item.vue';
import { ObjectModelRecordMetadataOption } from "~/models/dynamicFields/options/objectModelRecordMetadataOptions";
import {ReferenceNodeType} from "~/enums/referenceNodeType";

export default Vue.extend({
  name: "object-model-relationship-data",
  mixins: [handlerComponentsMixin, handlerTreeContextMixin, DynamicElementMixin],
  components: {
    CollapsibleSection,
    RelationData: () => import("./relation-data.vue"),
    ObjectModelAccountRelationData,
    FieldItem,
  },
  data: function () {
      return {
        ObjectModelPropertyDefinition: ObjectModelPropertyDefinition,
      };
    },
  props: {
    handler: {
      // ProcessFlowObjectModelDynamicFieldsHandler | ObjectModelAccountRelationDynamicFieldsHandler
      type: DynamicFieldsHandler,
      required: true,
    },
    objectModel: {
      type: Object as () => ObjectModel,
      required: true,
    },
    level: {
      type: Number,
      required: true,
    },
    path: {
      type: Array as () => ReferencePathNode[],
      required: true,
    },
    startOpened: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    treeContext(): IDynamicTreeContext {
      return {
        parent: this.objectModel,
        isTopLevelCollectionAssigned:
          this.parentTreeContext.isTopLevelCollectionAssigned ||
          this.handler.isTopLevelCollection(this.objectModel, this.parentTreeContext),
        referencePathNodesToLevel: this.path,
      };
    },
  },
  methods: {
    completePathFor(prop: ObjectModelRecordMetadataOption): ReferencePathNode[] {
      if (!this.path) return null;
      return [
          ...this.path,
          new ReferencePathNode(null, {reference_type: ReferenceNodeType.ObjectModelRecordMetadata, reference_id: prop.type}),
      ]
    },
  }
});
</script>